import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BelvoirAdminLoginLayout from './BelvoirAdminLoginLayout';

const PRODUCT_SLIDES = [
  {
    label: 'Documentation',
    headline:
      'In-app docs for Vennersys, Attractis, Admin, and API — guidance for Belvoir teams in one place.',
  },
  {
    label: 'Job Applications',
    headline:
      'Review CVs, cover letters, and application status — shortlist and track candidates as they progress.',
  },
  {
    label: 'Error Monitoring',
    headline:
      'Catch system issues early, run maintenance mode, and keep an eye on website and booking health.',
  },
  {
    label: 'Security Centre',
    headline:
      'Documentation, audits, afternoon tea bookings, job applications, and system status in one hub.',
  },
];

/**
 * AdminLogin - Security Centre sign-in.
 * Accepts onSuccess callback to notify parent when authenticated.
 */
const AdminLogin = ({ onSuccess }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token && onSuccess) {
      onSuccess();
    }
  }, [onSuccess]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch('https://api.belvoircastle.com/api/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (response.ok) {
        localStorage.setItem('token', data.token);
        localStorage.setItem('user', JSON.stringify(data.user));
        if (onSuccess) onSuccess();
        navigate('/security-center', { replace: true });
      } else {
        setError(data.message || 'Login failed');
        setLoading(false);
      }
    } catch (err) {
      setError('Login failed. Please try again.');
      setLoading(false);
    }
  };

  return (
    <BelvoirAdminLoginLayout
      productLabel="Security Centre"
      credentialsHint="Use your Belvoir Data Centre credentials."
      slides={PRODUCT_SLIDES}
      showcaseFooter="Belvoir Castle Security Centre"
      email={email}
      password={password}
      error={error}
      loading={loading}
      onEmailChange={(e) => setEmail(e.target.value)}
      onPasswordChange={(e) => setPassword(e.target.value)}
      onSubmit={handleSubmit}
      emailId="security-centre-email"
      passwordId="security-centre-password"
    />
  );
};

export default AdminLogin;
